/* Cafe Route menu page behaviour
   - Builds the sticky category nav from the menu group sections on the page
   - Keeps the nav clear of the theme's sticky header
   - Sourdough / Route nest photo toggle
   - Scroll reveal (respects reduced motion) */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observers = [];

  function headerOffset() {
    var header = document.querySelector('.xo-header__sticky');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.height === 0) return 0;
    return Math.min(Math.max(rect.bottom, 0), 220);
  }

  function navHeight() {
    var nav = document.querySelector('[data-crm-nav]');
    return nav && !nav.hidden ? nav.offsetHeight : 0;
  }

  function scrollToEl(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - navHeight() - 16;
    window.scrollTo({ top: top, behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  function clearObservers() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
  }

  function buildNav() {
    var nav = document.querySelector('[data-crm-nav]');
    if (!nav) return;
    var tabsWrap = nav.querySelector('[data-crm-tabs]');
    var subsWrap = nav.querySelector('[data-crm-subs]');
    var groups = Array.prototype.slice.call(document.querySelectorAll('.crm-group[data-crm-tab]'));
    tabsWrap.innerHTML = '';
    subsWrap.innerHTML = '';
    if (!groups.length) { nav.hidden = true; return; }

    groups.forEach(function (group, index) {
      var tab = document.createElement('a');
      tab.className = 'crm-nav__tab' + (index === 0 ? ' is-active' : '');
      tab.href = '#' + group.id;
      tab.textContent = group.getAttribute('data-crm-tab');
      tab.setAttribute('data-crm-target', group.id);
      tabsWrap.appendChild(tab);

      var cats = group.querySelectorAll('.crm-cat[data-crm-sub]');
      if (cats.length > 1) {
        var row = document.createElement('div');
        row.className = 'crm-nav__sub';
        row.setAttribute('data-crm-for', group.id);
        if (index !== 0) row.hidden = true;
        Array.prototype.forEach.call(cats, function (cat) {
          var link = document.createElement('a');
          link.className = 'crm-nav__sublink';
          link.href = '#' + cat.id;
          link.textContent = cat.getAttribute('data-crm-sub');
          link.setAttribute('data-crm-target', cat.id);
          row.appendChild(link);
        });
        subsWrap.appendChild(row);
      }
    });
    nav.hidden = false;

    if (!nav.hasAttribute('data-crm-bound')) {
      nav.setAttribute('data-crm-bound', 'true');
      nav.addEventListener('click', function (event) {
        var link = event.target.closest('[data-crm-target]');
        if (!link) return;
        event.preventDefault();
        var target = document.getElementById(link.getAttribute('data-crm-target'));
        scrollToEl(target);
        if (history.replaceState) history.replaceState(null, '', '#' + link.getAttribute('data-crm-target'));
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var groupObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id;
        nav.querySelectorAll('.crm-nav__tab').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-crm-target') === id);
        });
        nav.querySelectorAll('.crm-nav__sub').forEach(function (r) {
          r.hidden = r.getAttribute('data-crm-for') !== id;
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    groups.forEach(function (g) { groupObs.observe(g); });
    observers.push(groupObs);

    var catObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        nav.querySelectorAll('.crm-nav__sublink').forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('data-crm-target') === entry.target.id);
        });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    document.querySelectorAll('.crm-cat[data-crm-sub]').forEach(function (c) { catObs.observe(c); });
    observers.push(catObs);
  }

  /* The nav lives inside its own section, so CSS sticky would stop at the
     section edge. Instead it is fixed while the menu content is on screen. */
  var ticking = false;
  function updateNavTop() {
    ticking = false;
    var nav = document.querySelector('[data-crm-nav]');
    if (!nav || nav.hidden) return;
    var slot = nav.parentElement;
    var blocks = document.querySelectorAll('.crm-group, .crm-info');
    var last = blocks.length ? blocks[blocks.length - 1] : null;
    var offset = headerOffset();
    var height = nav.offsetHeight;
    var slotTop = slot.getBoundingClientRect().top;
    var endBottom = last ? last.getBoundingClientRect().bottom : 0;
    var shouldFix = slotTop <= offset && endBottom > offset + height;
    nav.style.setProperty('--crm-nav-top', offset + 'px');
    if (shouldFix && !nav.classList.contains('is-fixed')) {
      slot.style.height = height + 'px';
      nav.classList.add('is-fixed');
    } else if (!shouldFix && nav.classList.contains('is-fixed')) {
      nav.classList.remove('is-fixed');
      slot.style.height = '';
    }
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(updateNavTop); }
  }

  function initToggles(root) {
    root.querySelectorAll('[data-crm-toggle]').forEach(function (group) {
      if (group.getAttribute('data-crm-ready')) return;
      group.setAttribute('data-crm-ready', 'true');
      var card = group.closest('.crm-card');
      group.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-crm-show]');
        if (!btn) return;
        var index = btn.getAttribute('data-crm-show');
        group.querySelectorAll('[data-crm-show]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (card) {
          card.querySelectorAll('[data-crm-img]').forEach(function (img) {
            img.classList.toggle('is-hidden', img.getAttribute('data-crm-img') !== index);
          });
        }
      });
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.crm-anim:not(.is-visible)');
    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var revealObs = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    items.forEach(function (el) { revealObs.observe(el); });
    observers.push(revealObs);
  }

  function init() {
    clearObservers();
    buildNav();
    initToggles(document);
    initReveal(document);
    updateNavTop();
    if (window.location.hash) {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target && target.closest('.crm')) {
        window.setTimeout(function () { scrollToEl(target); }, 350);
      }
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
